import { LiveAnnouncer } from '@angular/cdk/a11y';
import {
  ChangeDetectorRef,
  Component,
  Inject,
  OnInit,
  ViewChild
} from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA
} from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { map, switchMap } from 'rxjs';
import { IncidenciaOperativaModel } from 'src/app/model/file/model.file';
import { FileService } from 'src/app/services/api/file.service';
import { FunctionsService } from 'src/app/services/api/functions.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-dialog-service-historial',
  templateUrl: './dialog-service-historial.component.html',
  styleUrls: ['./dialog-service-historial.component.css']
})
export class DialogServiceHistorialComponent implements OnInit {
  columnsTable: string[] = [
    'nombreServicio',
    'tipoServicio',
    'proveedorServicio',
    'fecha',
    'user'
  ];

  isLoading: boolean = false;
  loader: Boolean = false;
  type: string | null = null;
  dataFileToUpdated: any = null;
  arrayServices: string[] = [];
  arrayProviders: string[] = [];
  arrayTypesServices: string[] = [];
  serviceSelected: string | null = null;
  providerSelected: string | null = null;
  typeServiceSelected: string | null = null;
  loading: boolean = false;
  dataServices = new MatTableDataSource<any>();
  saving: boolean = false;
  infoService: any = {};
  historial: any;

  @ViewChild(MatPaginator) set paginator(value: MatPaginator) {
    this.dataServices.paginator = value;
  }
  @ViewChild(MatSort) set sort(value: MatSort) {
    this.dataServices.sort = value;
  }

  isExpanded = false;

  transform(array: any) {
    const result = array?.map((item: any) => JSON.parse(item));
    return result;
  }

  toggleHistorial() {
    this.isExpanded = !this.isExpanded;
  }

  constructor(
    public dialogRef: MatDialogRef<DialogServiceHistorialComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private changeDetectorRefs: ChangeDetectorRef,
    private fileService: FileService,
    public functionService: FunctionsService,
    public dialog: MatDialog,
    private _liveAnnouncer: LiveAnnouncer
  ) {}

  ngOnInit(): void {
    console.log('this.data.data', this.data.data);
    this.fileService
      .getHistorialByIdActivity(this.data.data.idActivity)
      .subscribe((res: any) => {
        console.log('res', res);
        this.historial = res.getHistorialByIdActivity;
        this.data.data.lstServicios.forEach((servicio: any) => {
          servicio.historial = [];

          this.historial?.forEach((historialItem: any) => {
            if (historialItem.idServiceItinerary === servicio.id) {
              servicio.historial.push(historialItem);
            }
          });
        });

        this.dataServices = new MatTableDataSource(this.data.data.lstServicios);
        this.type = this.data.type;
        this.dataServices.paginator = this.paginator;
        this.dataServices.sort = this.sort;
        this.changeDetectorRefs.detectChanges();
      });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  close() {
    this.dialogRef.close();
  }

  addIncidenciaToService(
    row_obj: any,
    numberFile: string,
    itineraryId: string
  ) {
    this.infoService.idItinerary = itineraryId;
    this.infoService.day = this.data.data.day;
    this.infoService.idServicio = row_obj.id;

    this.loading = true;
    let incidenciasOfService: any;
    this.data.data.lstServicios.map((value: any) => {
      if (value.id == row_obj.id) {
        let lstIncidencias: IncidenciaOperativaModel[];
        lstIncidencias = value.incidencias ? value.incidencias : [];
        lstIncidencias.push({ ...row_obj.data.incidencia });
        value.incidencias = lstIncidencias;

        incidenciasOfService = value;

        return incidenciasOfService;
      }

      return value;
    });

    this.fileService
      .getDetailsByFile(itineraryId)
      .pipe(
        switchMap((dataDetailsFiles: any) => {
          this.loader = true;
          this.dataFileToUpdated = dataDetailsFiles.getServicesByFile;

          const itinerariosUpdated = this.dataFileToUpdated.itinerarios.map(
            (ity: any) => {
              return {
                ...ity,
                services: ity.services.map((service: any) => {
                  if (service.id === incidenciasOfService.id) {
                    service.incidencias = incidenciasOfService.incidencias;

                    return service;
                  } else {
                    return service;
                  }
                })
              };
            }
          );
          this.dataFileToUpdated = {
            ...this.dataFileToUpdated,
            itinerarios: itinerariosUpdated
          };

          return this.fileService
            .updateActivity(this.dataFileToUpdated as any)
            .pipe(map((result) => {}));

          // return ''
        })
      )
      .subscribe({
        next: (value3) => console.log(value3),
        error: (error) => console.error(error),
        complete: () => {
          this.loading = false;
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'Se creo la incidencia',
            showConfirmButton: false,
            timer: 4000
          });

          this.ngOnInit();
          this.infoService.day = null;
          this.infoService.fileNumber = null;
        }
      });
  }

  openHistorial(historial: any) {
    this.functionService.openDialogHistorial(historial);
  }

  save(): void {
    this.saving = true;
  }
}
